import { Config } from '@/app/constants';
import { createIndexedDbStore } from './indexedDbStore';
import { queryClient } from './queryClient';
import { createQueryPersistence, type QueryPersistence } from './queryPersistence';

/** Read from storage, not the auth store: the auth controller itself clears this cache. */
function storedUserId(): string | null {
  try {
    const raw = localStorage.getItem(Config.storage.keys.user);
    const parsed: unknown = raw ? JSON.parse(raw) : null;
    if (parsed && typeof parsed === 'object' && 'id' in parsed && typeof parsed.id === 'string') {
      return parsed.id;
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * Teams, rosters and matches readable offline (VOL-14). `VITE_OFFLINE_QUERY_CACHE=false`
 * turns it off at build time without touching live entry.
 */
export const offlineQueryCache: QueryPersistence | null =
  import.meta.env.VITE_OFFLINE_QUERY_CACHE === 'false'
    ? null
    : createQueryPersistence({ client: queryClient, store: createIndexedDbStore(), userId: storedUserId });
